import { isArray, isString } from 'lodash-es'

import { type Assignment } from '@/state/assignments/types'
import { type Region } from '@/state/regions/types'

export interface RegionAssignment extends Assignment {
  region?: Region
}

export interface GlobalAssignment extends Assignment {
  regionsCount: number
  regions: Region[]
}

export const regionAssignments = (assignments: Assignment[], regions: Region[]): RegionAssignment[] =>
  assignments.flatMap((assignment) => {
    if (!isString(assignment.regionId) || assignment.type !== 'region') {
      return []
    }
    const region = regions.find((r) => r._id === assignment.regionId)
    return [
      {
        ...assignment,
        region,
      },
    ]
  })

export const globalAssignments = (assignments: Assignment[], regions: Region[]): GlobalAssignment[] =>
  assignments.flatMap((assignment) => {
    if (!isArray(assignment.regionId) || assignment.type !== 'global') {
      return []
    }
    const regionIds = assignment.regionId
    const matchedRegions = regions.filter((r) => regionIds.includes(r._id))
    return [
      {
        ...assignment,
        regionsCount: regionIds.length,
        regions: matchedRegions,
      },
    ]
  })
